import DraggableSvg from '../../../assets/draggable.svg?react';
import { IconProps } from '../../types/IconProps';

export function Draggable({ size = 20, ...props }: IconProps) {
  return <DraggableSvg data-testid="draggable-icon" width={size} height={size} {...props} />;
}

export default Draggable;
